<template>
  <div class="field-msg" v-if="isAutoLoginSuccess()">
    <div class="center">
      <img src="../../assets/img/login-success.png" class="success-img"/>
      <span class="success-text">登录成功</span>
      <span class="success-time">上次登录时间: {{currentInfo.lastAuthenticationTime}}</span>
    </div>
    <div class="footer">
      <van-button
        class="btn"
        :loading="reLoginETaxLoading"
        type="info"
        loading-text="登录中..."
        @click="reLoginETax"
      >
        重新登录电子税局
      </van-button>
    </div>
  </div>
  <div class="field-msg" v-else-if="isAutoLoginField()">
    <div class="center">
      <img src="../../assets/img/login-faild.png" class="field-img"/>
      <span class="field-text">登录失败</span>
      <span class="field-time">上次登录时间: {{currentInfo.lastAuthenticationTime}}</span>
    </div>
    <div class="footer">
      <van-button
        class="btn"
        :loading="reLoginETaxLoading"
        type="info"
        loading-text="登录中..."
        @click="reLoginETax"
      >
        重新登录电子税局
      </van-button>
    </div>
  </div>
  <div class="face-recognition" v-else-if="isGetResult">
    <div class="content">
      <van-radio-group class="radio-group" :value="loginParams.loginType" direction="horizontal">
        <van-radio icon-size="16" :name="0" @click="() => handleRadioClick(0)">短信验证</van-radio>
        <van-radio icon-size="16" :name="1" @click="() => handleRadioClick(1)">税务APP扫码</van-radio>
      </van-radio-group>
      <div class="describe">
        登录成功后系统会自动保活 6H，每次操作业务后都会顺延保活时长
      </div>
      <SmsLogin v-if="loginParams.loginType === 0" :getLoginResults="getLoginResults"/>
      <QrCodeLoginVue v-if="loginParams.loginType === 1" :getLoginResults="getLoginResults"/>
    </div>
  </div>
</template>

<script>
import { RadioGroup, Radio, Notify, Button } from 'vant'
import QrCodeLoginVue from './QrCodeLogin.vue'
import SmsLogin from './SmsLogin.vue'
import { getWebCache, setWebCache } from '@/utils/basicUtil.js'
import { invoiceRequest } from '@/services'
export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    QrCodeLoginVue,
    SmsLogin
  },
  computed: {

  },
  data () {
    return {
      loginParams: {
        loginType: getWebCache('loginType') || 0 // 登录类型 0账密（短信验证码）登录，1扫码登录
      },
      currentInfo: {},
      isGetResult: false,
      isLoading: false,
      reLoginETaxLoading: false
    }
  },
  async mounted () {
    this.getLoginResults()
  },
  methods: {
    handleRadioClick (type) {
      this.loginParams.loginType = type
      setWebCache('loginType', type)
    },
    /**
     * 首次进页面调用左上角缓存接口，登录成功过，就跳到成功界面，否则进项初始化逻辑
     */
    async getLoginResults () {
      this.isLoading = true
      const res = await invoiceRequest.allElectricLogin.getMsgLoginResult({})
      if (res.success) {
        if (res.result.result === 1) { //  登录成功
          this.currentInfo = res.result
        } else {
          this.isGetResult = true // 还没登录过,需要初始化登录一下
        }
      } else {
        if (res.message) Notify({ type: 'danger', message: res.message })
      }
      this.isLoading = false
    },
    isAutoLoginSuccess () {
      return Number(this.currentInfo.result) === 1
    },
    isAutoLoginField () {
      return Number(this.currentInfo.result) === 2
    },
    reLoginETax () {
      this.currentInfo = {}
      this.isGetResult = true
    }

  }
}
</script>
<style scoped lang='less'>
.face-recognition{
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgb(224, 219, 219);
  .content{
    flex-grow: 1;
  }
  .radio-group{
    font-size: 32px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .title, .describe{
    color: #000;
  }
  .describe {
    margin-top: 60px;
    font-size: 28px;
    font-weight: 400;
    color: #666;
    .tip{
      color: #297CF0;
    }
  }

}
.field-msg{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .center{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 600px;
    gap: 24px;
    .field-img{
      width: 280px;
    }
    .field-text{
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #DA5245;
      line-height: 48px;
    }
    .field-time{
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 48px;
      margin-top: 24px;
    }
    .success-img{
      width: 280px;
    }
    .success-text{
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #0D9F69;
      line-height: 48px;
    }
    .success-time{
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 48px;
      margin-top: 24px;
    }
  }
  .footer{
    width: 50%;
    padding: 0 24px;
    display: flex;
    box-sizing: border-box;
    .btn{
      padding: 16px 0;
      width: 100%;
      height: 100%;
      border-radius: 40px;
      font-size: 32px;
    }
  }
}
</style>
